// extracted by mini-css-extract-plugin
module.exports = {"editContent":"StoryboardEditor-moduleeditContent30M","miniSidebar":"StoryboardEditor-moduleminiSidebar4aW","spinner":"StoryboardEditor-modulespinnerMKc"};